import SearchIcon from '@mui/icons-material/Search'
import {IconButton, InputAdornment, TextField} from '@mui/material'
import {t} from 'i18next'
import {styles} from '../styles'
import {ReactComponent as CloseIcon} from '../assets/close.svg'

type AddressSearchBarProps = {
  value: string
  onChange: (value: string) => void
  onClear?: () => void
  placeholder?: string
}

export const AddressSearchBar: React.FC<AddressSearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = t('orderIntake.rmc.jobSiteModal.searchPlaceholder')
}) => {
  const handleClear = () => {
    onChange('')
    onClear?.()
  }

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    setTimeout(() => {
      const target = e.target as HTMLInputElement
      onChange(target.value)
    }, 0)
  }

  return (
    <TextField
      data-test-id="address-search-bar-input"
      sx={{
        ...styles.searchField,
        ...(value ? styles.searchFieldTransparent : {})
      }}
      placeholder={placeholder}
      variant="outlined"
      value={value}
      onChange={onTextChange}
      onPaste={handlePaste}
      size="medium"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value ? (
              <IconButton
                onClick={handleClear}
                edge="end"
                size="small"
                sx={styles.clearButton}
                data-test-id="address-clear-button"
              >
                <CloseIcon />
              </IconButton>
            ) : (
              <SearchIcon data-test-id="address-search-icon" />
            )}
          </InputAdornment>
        )
      }}
    />
  )
}
